<template>
  <div>
    Seats
  </div>
</template>

<script>
export default {

}
</script>
